import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/database";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD-JW32YkVirbjoLf8TExZCBbZFDMWnpCY",
  authDomain: "kuehnected.firebaseapp.com",
  databaseURL:
    "https://kuehnected-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kuehnected",
  storageBucket: "kuehnected.appspot.com",
  messagingSenderId: "744094337463",
  appId: "1:744094337463:web:b5434e057763a1c02a4032",
  measurementId: "G-K5QPSBSFL5",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

export class FirebaseService {
  public static dbRef() {
    return DatabaseRefs;
  }

  public static functions() {
    return firebase.functions();
  }
}

const DatabaseRefs = {
  test(): firebase.database.Reference {
    return firebase.database().ref(`test`);
  },
  deliveries(): firebase.database.Reference {
    return firebase.database().ref(`deliveries`);
  },
  codes(): firebase.database.Reference {
    return firebase.database().ref(`codes`);
  },
  helpareas(): firebase.database.Reference {
    return firebase.database().ref(`helpareas`);
  },
};
